import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { HOME } from "@/constants/testIds";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";

const links = [
    { href: "#founder", label: "Founder", testId: "nav-founder" },
    { href: "#services", label: "Services", testId: HOME.navServices },
    { href: "#reels", label: "Work", testId: "nav-reels" },
    { href: "#packages", label: "Packages", testId: HOME.navPackages },
    { href: "#team", label: "Team", testId: "nav-team" },
    { href: "#faq", label: "FAQ", testId: HOME.navFaq },
    { href: "#contact", label: "Contact", testId: HOME.navContact },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0A0A0A]/80 border-b border-white/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
                <Logo />

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testId}
                            className="text-sm font-medium text-white/70 hover:text-white transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <a
                        href="#book"
                        data-testid={HOME.navCta}
                        className="inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white text-sm font-semibold px-5 py-2.5 transition-colors"
                    >
                        <MessageCircle className="w-4 h-4" />
                        Book Call
                    </a>
                </div>

                <button
                    className="md:hidden text-white p-2"
                    onClick={() => setOpen(!open)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                >
                    {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-[#0A0A0A]">
                    <div className="px-5 py-4 flex flex-col gap-1">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="py-3 text-white/80 hover:text-brand transition-colors border-b border-white/5"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="https://wa.me/971543676278"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-3 inline-flex items-center justify-center gap-2 bg-brand text-white text-sm font-semibold px-5 py-3"
                        >
                            <MessageCircle className="w-4 h-4" /> Book Call
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
